export const notificationMock = [
  {
    id: '1',
    createdAt: 1599068101795,
    updatedAt: 1599068101952,
    group: 'financial',
    type: 'latePayment',
    date: null,
    dueDate: null,
    statusPercentage: null,
    statusType: null,
  },
  {
    id: '2',
    createdAt: 1599068098573,
    updatedAt: 1599068098630,
    group: 'construction',
    type: 'deliveryKeysSchedule',
    date: null,
    dueDate: null,
    statusPercentage: null,
    statusType: null,
  },
  {
    id: '3',
    createdAt: 1599061619442,
    updatedAt: 1599061619499,
    group: 'construction',
    type: 'finishedConstruction',
    date: null,
    dueDate: null,
    statusPercentage: null,
    statusType: null,
  },
  {
    id: '4',
    createdAt: 1599061619442,
    updatedAt: 1599061619499,
    group: 'schedule',
    type: 'visitScheduling',
    date: null,
    dueDate: null,
    statusPercentage: null,
    statusType: null,
  },
  {
    id: '5',
    createdAt: 1599061619442,
    updatedAt: 1599061619499,
    group: 'schedule',
    type: 'wasNotDrawn',
    date: null,
    dueDate: null,
    statusPercentage: null,
    statusType: null,
  },
  {
    id: '6',
    createdAt: 1599061619442,
    updatedAt: 1599061619499,
    group: 'schedule',
    type: 'wasDrawn',
    date: null,
    dueDate: null,
    statusPercentage: null,
    statusType: null,
  },
  {
    id: '7',
    createdAt: 1599061619442,
    updatedAt: 1599061619499,
    group: 'financial',
    type: 'closeDueDate',
    date: null,
    dueDate: null,
    statusPercentage: null,
    statusType: null,
  },
  {
    id: '8',
    createdAt: 1599061619442,
    updatedAt: 1599061619499,
    group: 'financial',
    type: 'newInstallment',
    date: null,
    dueDate: null,
    statusPercentage: null,
    statusType: null,
  },
  {
    id: '9',
    createdAt: 1599061619442,
    updatedAt: 1599061619499,
    group: 'schedule',
    type: 'visitDrawOpen',
    date: null,
    dueDate: null,
    statusPercentage: null,
    statusType: null,
  },
]
